export enum CrmIntegrationLicence {
    NONE = 'NONE',
    SOLO = 'SOLO',
    TEAMS = 'TEAMS',
    UNITE = 'UNITE'
}

export type SelfProvisioningInitalDataFormState = {
    siteName: string
    siteIndustry: string
    enterpriseID: string
    userName: string
    password: string
}

export type SelfProvisioningUser = {
    userType: string
    email: string
    name?: string
    welcomeEmail: boolean
    useEmailAsUsername?: boolean
    crmLicence?: string | CrmIntegrationLicence
}

export type SelfProvisioningUserFormState = {
    users: SelfProvisioningUser[]
}

export type CustomerReferenceForm = {
    customerReference: string
}

export type BaseWebhookObject = {
    userInformation: {
        cmeName: string
    }
    companyInformation: {
        companyName: string
        companySector: string
    }
    companyConfig: {
        telSysID: number
        partitionID: number
        deviceCount: number
        users: {
            reportingSupervisors: number
            oneUsers: number
        }
    }
    otherInformation: {
        customerReference: string
        timestamp: string
    }
}

export type EntityCreateStatus = 'CREATED' | 'SYNCED' | 'WAITING' | 'FAILED'
